module.exports = __webpack_public_path__ + "static/media/simongame.9961011c.png";